import {useMemo} from 'react'

import type {CleanupProjectPageUseIsReadOnlyFragment$key} from '../__generated__/CleanupProjectPageUseIsReadOnlyFragment.graphql'
import type {HolderType, Owner, PolicyEntry} from '../CleanupProjectPage.types'
import {getHolderNode, getPolicyHolderIds} from '../CleanupProjectPage.utils'

import Cleanup from './Rules/Rules.container'

type Props = {
  policy: PolicyEntry
  type: HolderType
  owner: Owner
  hideOwn?: boolean
  hideInherited?: boolean
  hideEnforced?: boolean
  showInherited?: boolean
  readOnlyProjectsKey: CleanupProjectPageUseIsReadOnlyFragment$key | null
}

function ListingRules({
  policy,
  showInherited,
  type,
  owner,
  hideOwn = false,
  hideInherited = false,
  hideEnforced = false,
  readOnlyProjectsKey,
}: Props) {
  const holderNode = useMemo(() => getHolderNode(policy, type), [policy, type])
  return (
    <Cleanup
      embedded
      isTemplate={type === 'template'}
      inheritedVisible={showInherited}
      hideOwn={hideOwn}
      hideInherited={hideInherited}
      hideEnforced={hideEnforced}
      buildTypeId={getPolicyHolderIds(policy, type).buildTypeId}
      projectId={owner.externalId}
      holderNode={holderNode}
      readOnlyProjectsKey={readOnlyProjectsKey}
    />
  )
}

export default ListingRules
